import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import { StyleSheet } from "react-native";

import { useContentResource } from "@ctv/core";
import {
  formatMessage,
  InputRHF,
  PhoneField,
  Token,
} from "@ctv/shared-core/src";
import { isEmail, isNumeric } from "@ctv/shared-core/src/utils/validation";

import { RegistrationFormValue } from "../../../types";
import { FieldRow } from "../../FieldRow";

export default function ReferenceCheck() {
  const { getValues } = useFormContext<RegistrationFormValue>();
  const { CorporateRegistration: cr } = useContentResource();

  const companyName = getValues("companyName");

  return (
    <Fragment>
      <FieldRow style={styles.spacingL} label={cr.partnerCompanyNameLabel}>
        <InputRHF
          name="partnerCompanyName"
          validate={(v) => {
            if (v === companyName) {
              return cr.partnerCompanySameNameErrorMessage;
            }

            return;
          }}
          onBlur={(value, onChange) => onChange(value.trim())}
          style={styles.input}
        />
      </FieldRow>
      <FieldRow style={styles.spacingL} label={cr.partnerCompanyRelationLabel}>
        <InputRHF
          name="partnerCompanyRelation"
          onBlur={(value, onChange) => onChange(value.trim())}
          style={styles.input}
        />
      </FieldRow>
      <FieldRow style={styles.spacingL} label={cr.partnerCompanyPicNameLabel}>
        <InputRHF
          name="partnerCompanyPicName"
          onBlur={(value, onChange) => onChange(value.trim())}
          style={styles.input}
        />
      </FieldRow>
      <FieldRow style={styles.spacingL} label={cr.partnerCompanyPicEmailLabel}>
        <InputRHF
          name="partnerCompanyPicEmail"
          validate={(v) => {
            if (v && !isEmail(v, true)) {
              return cr.validationEmailFormat;
            }

            return;
          }}
          onBlur={(value, onChange) => onChange(value.trim())}
          style={styles.input}
        />
      </FieldRow>
      <FieldRow style={styles.spacingL} label={cr.partnerCompanyPhoneLabel}>
        <PhoneField
          name="partnerCompanyPhone"
          validate={(v) => {
            if (v?.phone && !isNumeric(v?.phone, true)) {
              return formatMessage(cr.validationNumericOnly, {
                field: cr.partnerCompanyPhoneLabel,
              });
            }

            return;
          }}
          onBlur={(value, onChange) => onChange(value.phone.trim())}
          style={styles.input}
        />
      </FieldRow>
    </Fragment>
  );
}

const styles = StyleSheet.create({
  section: {
    marginTop: Token.spacing.xl,
    marginBottom: Token.spacing.m,
  },
  spacingM: {
    marginBottom: Token.spacing.m,
  },
  spacingL: {
    marginBottom: Token.spacing.l,
  },
  card: {
    padding: Token.spacing.l,
    overflow: "visible",
  },
  input: {
    flex: 1,
  },
});
